export default __webpack_public_path__ + "360c70352b11ba1e2d657cc332cab75d.svg";